/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuditData { 
    /**
     * the time at which the log event occurred
     */
    date_timestamp: Date;
    /**
     * The host ip the audit log originated from. Can be in ipv4 or ipv6.
     */
    ip: string;
    /**
     * The org id string involved in the audit log (Default - ALL ORGS)
     */
    org_id: string;
    /**
     * Request body
     */
    request_body: string;
    /**
     * URI path
     */
    uri_path: string;
    /**
     * API call triggered by
     */
    triggered_by: string;
    /**
     * API status code
     */
    status_code: number;
    /**
     * The type of the request
     */
    type: string;
    /**
     * String of the raw user id from the context making the audit log
     */
    user_id: string;
}

